
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: '品牌故事', href: '/about' },
    { name: '产品系列', href: '/products' },
    { name: '三地精粹', href: '/heritage' },
    { name: '联系我们', href: '/contact' },
  ];

  const legalLinks = [
    { name: '隐私政策', href: '/privacy' },
    { name: '用户协议', href: '/terms' },
    { name: '网站地图', href: '/sitemap' },
  ];

  return (
    <footer className="bg-[#2f3673] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 rounded-lg overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f21c56093101f07d70e4f03bb9372588.png" 
                  alt="狮虎堂 Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>狮虎堂</span>
                <span className="text-sm text-gray-300">LIONTIGER HUB</span>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              塑东方体魄，养狮虎人生。融汇三地精粹，唤醒沉睡在你体内的原生力量。
            </p>
            <div className="space-y-2 text-sm text-gray-300">
              <p><strong className="text-white">品牌方：</strong>中国狮虎堂中草药集团有限公司（香港）</p>
              <p><strong className="text-white">研发与生产：</strong>云南狮虎堂中药研发有限公司</p>
              <p><strong className="text-white">泰国商标：</strong>"狮虎堂LionTigerHub" 商标于泰国注册</p>
            </div>
          </div>

          {/* Quick Links and Contact Info - Mobile: side by side, Desktop: separate columns */}
          <div className="col-span-1 md:col-span-2 grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-8">
            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">快速导航</h3>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-300 hover:text-[#f7931d] transition-colors duration-200 cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4">联系我们</h3>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-center space-x-2">
                  <i className="ri-map-pin-line text-[#f7931d]"></i>
                  <span className="text-sm">香港特别行政区</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-phone-line text-[#f7931d]"></i>
                  <span className="text-sm">+852 xxxx xxxx</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-mail-line text-[#f7931d]"></i>
                  <span className="text-sm">info@liontiger.hk</span>
                </div>
              </div>
              
              {/* Social Media */}
              <div className="mt-6">
                <h4 className="text-sm font-semibold mb-3">关注我们</h4>
                <div className="flex space-x-3">
                  <button className="w-8 h-8 bg-gray-700 hover:bg-[#f7931d] rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer">
                    <i className="ri-wechat-fill text-sm"></i>
                  </button>
                  <button className="w-8 h-8 bg-gray-700 hover:bg-[#f7931d] rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer">
                    <i className="ri-weibo-fill text-sm"></i>
                  </button>
                  <button className="w-8 h-8 bg-gray-700 hover:bg-[#f7931d] rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer">
                    <i className="ri-facebook-fill text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-300 mb-4 md:mb-0">
              © 2024 狮虎堂 LIONTIGER HUB。版权所有。
            </div>
            <div className="flex flex-wrap items-center gap-3 md:gap-6 text-sm">
              {legalLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-300 hover:text-[#f7931d] transition-colors duration-200 cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#f7931d] transition-colors duration-200 cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
